import { db } from 'src/db/db';

export default async (uid = '') => {
    const userSnap = await db.collection('users').doc(uid).get();
    if (userSnap.exists) {
      if (userSnap.data().artist) {
        const musicianData = await getMusician(userSnap.data().artist);
        musicianData.artist = userSnap.data().artist
        return musicianData
      }
    }
}
    

  const getMusician = async (musicianName) => {
    const musicianSnap = await db.collection('musicians').doc(musicianName).get();
    if (musicianSnap.exists) {
      return musicianSnap.data();
    }
  };
